import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import {
	CompanyDealCreationTriggerResponse,
	CompanyLeadSyncTriggerResponse,
	CompanySyncTriggerResponse,
	ConversationSyncResponse,
	HubspotFieldsResponse,
	HubspotOwnersResponse,
	HubspotPipelinesResponse,
	LeadConfigResponse,
} from "../../pages/Company/schema/hubspot";
import { hubspotApi } from "./hubspot.api";

interface HubspotState {
	companySyncTrigger: CompanySyncTriggerResponse | null;
	companyDealCreationTrigger: CompanyDealCreationTriggerResponse | null;
	companyLeadSyncTrigger: CompanyLeadSyncTriggerResponse | null;
	conversationSync: ConversationSyncResponse | null;
	leadConfig: LeadConfigResponse | null;
	leadFields: HubspotFieldsResponse | null;
	leadPipelines: HubspotPipelinesResponse | null;
	owners: HubspotOwnersResponse | null;
}

const initialState: HubspotState = {
	companySyncTrigger: null,
	companyDealCreationTrigger: null,
	companyLeadSyncTrigger: null,
	conversationSync: null,
	leadConfig: null,
	leadFields: null,
	leadPipelines: null,
	owners: null,
};

export const hubspotSlice = createSlice({
	name: "hubspot",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			hubspotApi.endpoints.getCompanySyncTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companySyncTrigger = payload;
			}
		);
		builder.addMatcher(
			hubspotApi.endpoints.updateCompanySyncTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companySyncTrigger = payload;
			}
		);
		builder.addMatcher(
			hubspotApi.endpoints.getCompanyDealCreationTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companyDealCreationTrigger = payload;
			}
		);
		builder.addMatcher(
			hubspotApi.endpoints.updateCompanyDealCreationTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companyDealCreationTrigger = payload;
			}
		);
		builder.addMatcher(
			hubspotApi.endpoints.getCompanyLeadSyncTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companyLeadSyncTrigger = payload;
			}
		);
		builder.addMatcher(
			hubspotApi.endpoints.updateCompanyLeadSyncTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companyLeadSyncTrigger = payload;
			}
		);
		builder.addMatcher(
			hubspotApi.endpoints.getConversationSync.matchFulfilled,
			(state, { payload }) => {
				state.conversationSync = payload;
			}
		);
		builder.addMatcher(
			hubspotApi.endpoints.updateConversationSync.matchFulfilled,
			(state, { payload }) => {
				state.conversationSync = payload;
			}
		);
		builder.addMatcher(hubspotApi.endpoints.getLeadConfig.matchFulfilled, (state, { payload }) => {
			state.leadConfig = payload;
		});
		builder.addMatcher(hubspotApi.endpoints.saveLeadConfig.matchFulfilled, (state, { payload }) => {
			state.leadConfig = payload;
		});
		builder.addMatcher(
			hubspotApi.endpoints.getHubspotLeadFields.matchFulfilled,
			(state, { payload }) => {
				state.leadFields = payload;
			}
		);
		builder.addMatcher(
			hubspotApi.endpoints.getHubspotLeadPipelines.matchFulfilled,
			(state, { payload }) => {
				state.leadPipelines = payload;
			}
		);
		builder.addMatcher(
			hubspotApi.endpoints.getHubspotOwners.matchFulfilled,
			(state, { payload }) => {
				state.owners = payload;
			}
		);
	},
});

export const hubspotReducer = hubspotSlice.reducer;
export const hubspotSelector = (state: RootState) => state[hubspotSlice.name];
